// extracted by mini-css-extract-plugin
export default {"item":"CardVideo_item__kdXPx","video":"CardVideo_video__OKw+w"};